// extracted by mini-css-extract-plugin
module.exports = {"title":"GripTeamDetailCard_title_aBRwH","spinAround":"GripTeamDetailCard_spinAround_3wgCV"};